import React, { useState } from "react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import peopleImage from './Assets/peopleImage.png';
import LeftPoint1 from "./Assets/points1.png";
import LeftPoint2 from "./Assets/LeftPoint2.png";
import LeftPoint3 from "./Assets/LeftPoint3.png";
import LeftPoint4 from "./Assets/LeftPoint4.png";
import LeftPoint5 from "./Assets/LeftPoint5.png";
import Rightpoint1 from "./Assets/Rightpoint1.png";
import Rightpoint2 from "./Assets/RightPoint2.png";
import Rightpoint3 from "./Assets/RightPoint3.png";
import Rightpoint4 from "./Assets/RightPoint4.png";
import Rightpoint5 from "./Assets/RightPoint5.png";
import FrequentlyAskedQuestions from "./FAQ";
import VLIAddValueMobile from "./Assets/MobileVLIAdd.png";  

const HowVLIAddValueBtn = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleContent = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="w-full flex justify-center items-center mt-[-100px] mb-[50px] z-99 relative">
        <div className="w-full lg:w-[90%] 2.5xl:w-[80%]">
            <button
                onClick={toggleContent}
                className={`w-[275px] h-[55px] ml-[30px] lg:ml-[0px] rounded-[12px] cursor-pointer text-[26px] border-3 transition-all duration-300
                ${isOpen
                    ? "bg-white text-[#A1A3EF] border-[#A1A3EF]"
                    : "bg-[#A1A3EF] text-white border-transparent"
                }`}
                style={{ border: isOpen ? "3px solid #A1A3EF" : "0" }}
            >
                <div className="flex justify-center items-center gap-2">
                How VLI Add Value
                <span className="text-[30px]">
                    {isOpen ? <KeyboardArrowDownIcon style={{ color: "#A1A3EF", width: "20px" }} /> : <ArrowForwardIosIcon style={{ color: "#FFFFFF" }} />}
                </span>
                </div>
            </button>

            {isOpen && (
                <>
                    <div className="hidden lg:flex relative w-full pt-[50px] overflow-hidden mt-[50px]">
                        {/* Background split */}
                        <div className="absolute inset-0 flex z-0">
                            <div className="w-1/2 bg-white"></div>
                            <div className="w-1/2 bg-[#572E8F]"></div> 
                        </div>

                        {/* Content above background */}
                        <div className="relative z-10 grid grid-cols-1 md:grid-cols-3 gap-[10px] ">

                            {/* Left Section */}
                            <div className="text-left flex flex-col gap-[30px] z-[30]">
                                <h3 className="italic font-semibold text-[25px]">
                                    (For Vehicle Training Institutes & Instructors (Our Partners))
                                </h3>
                                <p className="text-[24px] text-left leading-[41px]">
                                    Vehicle Learning Innovation (VLI) helps your institute grow smarter, scale faster, and lead in the vehicle training education space with next generation tools powered by AI and unmatched visibility.
                                </p>
                                <div className="w-full flex flex-col gap-[15px]">
                                    <div className="flex gap-[15px] items-center">
                                        <img src={LeftPoint1} alt="point 1" />
                                        <div className="flex flex-col">
                                            <p className="text-[18px] font-bold">Enhanced Reputation</p>
                                            <p className="text-[18px]">Position your institute as a pioneer in the digital vehicle training ecosystem by leveraging our advanced, learner-centric technology.</p>
                                        </div>
                                    </div>

                                    <div className="flex gap-[15px] items-center">
                                        <img src={LeftPoint2} alt="point 1" />
                                        <div className="flex flex-col">
                                            <p className="text-[18px] font-bold">Increased Visibility</p>
                                            <p className="text-[18px]">Stand out in a competitive market with your verified profile on our high-traffic platform with complete ratings, real learner reviews, and cutting edge technology</p>
                                        </div>
                                    </div>

                                    <div className="flex gap-[15px] items-center">
                                        <img src={LeftPoint3} alt="point 1" />
                                        <div className="flex flex-col">
                                            <p className="text-[18px] font-bold">Centralized</p>
                                            <p className="text-[18px]">Simplify your operations lifecycle — manage enrollments, schedules, instructors, and performance all in one place.</p>
                                        </div>
                                    </div>

                                    <div className="flex gap-[15px] items-center">
                                        <img src={LeftPoint4} alt="point 1" />
                                        <div className="flex flex-col">
                                            <p className="text-[18px] font-bold">Smart Lead Generation</p>
                                            <p className="text-[18px]">Connect with high-intent learners actively searching for reliable training partners. No cold outreach — just warm leads.</p>
                                        </div>
                                    </div>

                                    <div className="flex gap-[15px] items-center pb-[50px]">
                                        <img src={LeftPoint5} alt="point 1" />
                                        <div className="flex flex-col">
                                            <p className="text-[18px] font-bold">Real-Time Engagement</p>
                                            <p className="text-[18px]">Respond instantly to learner inquiries, customize offerings, and build stronger relationships with your audience through built-in conversation tools.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Center Image */}
                            {/* <div className="flex justify-end items-end">
                            <img
                                src={peopleImage}
                                alt="VLI People"
                                className="w-full h-[600px]"
                            />
                            </div> */}
                            {/* Center Image */}
                            <div className="flex justify-center items-end h-full z-[20]">
                            <img
                                src={peopleImage}
                                alt="VLI People"
                                className="max-h-[700px] 2.5xl:max-h-[700px] object-contain self-end"
                            />
                            </div>

                            {/* Right Section */}
                            <div className="text-left md:text-right flex flex-col gap-[30px] text-white pr-[50px] 2.5xl:pr-[80px] z-[30]">
                            <h3 className="italic font-semibold text-[25px]">
                                For Students & Learners
                            </h3>
                            <h3></h3>
                            <p className="text-[24px] text-right leading-[41px]">
                                VLI is your all-in-one platform to start, manage, and succeed in your vehicle learning journey — whether you’re a beginner or looking to upgrade your license.
                            </p>
                            <div className="w-full flex flex-col gap-[15px] mt-[30px]">
                                    <div className="flex gap-[15px] items-center">
                                        <div className="flex flex-col">
                                            <p className="text-[18px] font-bold">Convenience</p>
                                            <p className="text-[18px]">Find, Compare, Enroll anytime, anywhere on our user-friendly platform, built for today’s mobile lifestyle.</p>
                                        </div>
                                        <img src={Rightpoint1} alt="point 1" />
                                    </div>

                                    <div className="flex gap-[15px] items-center">
                                        <div className="flex flex-col">
                                            <p className="text-[18px] font-bold">Personalized Dashboard</p>
                                            <p className="text-[18px]">Easy onboarding, custom scheduling, Conversation support, and real-time progress updates — all designed to fit your pace and preferences.</p>
                                        </div>
                                        <img src={Rightpoint2} alt="point 1" />
                                    </div>

                                    <div className="flex gap-[15px] items-center">
                                        <div className="flex flex-col">
                                            <p className="text-[18px] font-bold">Progress Monitoring</p>
                                            <p className="text-[18px]">Track your advancement with visual insights and reminders to keep you on the road toward success.</p>
                                        </div>
                                        <img src={Rightpoint3} alt="point 1" />
                                    </div>

                                    <div className="flex gap-[15px] items-center">
                                        <div className="flex flex-col">
                                            <p className="text-[18px] font-bold">MOT Approved Instructors</p>
                                            <p className="text-[18px]">Choose from verified vehicle learning training institutes and instructors, complete with ratings and real feedback, so you always feel confident in your choice.</p>
                                        </div>
                                        <img src={Rightpoint4} alt="point 1" />
                                    </div>

                                    <div className="flex gap-[15px] items-center pb-[50px]">
                                        <div className="flex flex-col">
                                            <p className="text-[18px] font-bold">AI-Powered Platform</p>
                                            <p className="text-[18px]">We use intelligent technology to match you with the best-fit institute based on your locality, need, and goals.</p>
                                        </div>
                                        <img src={Rightpoint5} alt="point 1" />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="flex lg:hidden relative w-full overflow-hidden mt-[40px]">
                        {/* Content above background */}
                        <div className="relative z-10 grid grid-cols-1 md:grid-cols-3 gap-[10px] ">

                            {/* Left Section */}
                            <div className="w-full flex items-center justify-center">
                                <div className=" w-[90%] text-left flex flex-col gap-[30px] z-[30]">
                                    <h3 className="italic font-semibold text-[24px] leading-[32px]">
                                        (For Vehicle Training Institutes & Instructors (Our Partners))
                                    </h3>
                                    <p className="text-[20px] text-left leading-[41px] mt-[-10px]">
                                        Vehicle Learning Innovation (VLI) helps your institute grow smarter, scale faster, and lead in the vehicle training education space with next generation tools powered by AI and unmatched visibility.
                                    </p>
                                    <div className="w-full flex flex-col gap-[15px]">
                                        <div className="flex gap-[15px] items-center">
                                            <img src={LeftPoint1} alt="point 1" />
                                            <div className="flex flex-col">
                                                <p className="text-[18px] font-bold">Enhanced Reputation</p>
                                                <p className="text-[18px]">Position your institute as a pioneer in the digital vehicle training ecosystem by leveraging our advanced, learner-centric technology.</p>
                                            </div>
                                        </div>

                                        <div className="flex gap-[15px] items-center">
                                            <img src={LeftPoint2} alt="point 1" />
                                            <div className="flex flex-col">
                                                <p className="text-[18px] font-bold">Increased Visibility</p>
                                                <p className="text-[18px]">Stand out in a competitive market with your verified profile on our high-traffic platform with complete ratings, real learner reviews, and cutting edge technology</p>
                                            </div>
                                        </div>

                                        <div className="flex gap-[15px] items-center">
                                            <img src={LeftPoint3} alt="point 1" />
                                            <div className="flex flex-col">
                                                <p className="text-[18px] font-bold">Centralized</p>
                                                <p className="text-[18px]">Simplify your operations lifecycle — manage enrollments, schedules, instructors, and performance all in one place.</p>
                                            </div>
                                        </div>

                                        <div className="flex gap-[15px] items-center">
                                            <img src={LeftPoint4} alt="point 1" />
                                            <div className="flex flex-col">
                                                <p className="text-[18px] font-bold">Smart Lead Generation</p>
                                                <p className="text-[18px]">Connect with high-intent learners actively searching for reliable training partners. No cold outreach — just warm leads.</p>
                                            </div>
                                        </div>

                                        <div className="flex gap-[15px] items-center pb-[50px]">
                                            <img src={LeftPoint5} alt="point 1" />
                                            <div className="flex flex-col">
                                                <p className="text-[18px] font-bold">Real-Time Engagement</p>
                                                <p className="text-[18px]">Respond instantly to learner inquiries, customize offerings, and build stronger relationships with your audience through built-in conversation tools.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/* Right Section */}
                            <div className="text-left bg-[#572E8F] w-full md:text-right flex flex-col gap-[30px] text-white px-[15px] 2.5xl:pr-[80px] z-[30]">
                                <h3 className="italic font-semibold text-[24px] text-right mt-[20px]">
                                    For Students & Learners
                                </h3>
                                <p className="text-[20px] text-right leading-[41px]">
                                    VLI is your all-in-one platform to start, manage, and succeed in your vehicle learning journey — whether you’re a beginner or looking to upgrade your license.
                                </p>
                                <div className="w-full flex flex-col gap-[15px] mt-[20px] text-right">
                                        <div className="flex gap-[15px] items-center">
                                            <div className="flex flex-col">
                                                <p className="text-[18px] font-bold">Convenience</p>
                                                <p className="text-[18px]">Find, Compare, Enroll anytime, anywhere on our user-friendly platform, built for today’s mobile lifestyle.</p>
                                            </div>
                                            <img src={Rightpoint1} alt="point 1" />
                                        </div>

                                        <div className="flex gap-[15px] items-center">
                                            <div className="flex flex-col">
                                                <p className="text-[18px] font-bold">Personalized Dashboard</p>
                                                <p className="text-[18px]">Easy onboarding, custom scheduling, Conversation support, and real-time progress updates — all designed to fit your pace and preferences.</p>
                                            </div>
                                            <img src={Rightpoint2} alt="point 1" />
                                        </div>

                                        <div className="flex gap-[15px] items-center">
                                            <div className="flex flex-col">
                                                <p className="text-[18px] font-bold">Progress Monitoring</p>
                                                <p className="text-[18px]">Track your advancement with visual insights and reminders to keep you on the road toward success.</p>
                                            </div>
                                            <img src={Rightpoint3} alt="point 1" />
                                        </div>

                                        <div className="flex gap-[15px] items-center">
                                            <div className="flex flex-col">
                                                <p className="text-[18px] font-bold">MOT Approved Instructors</p>
                                                <p className="text-[18px]">Choose from verified vehicle learning training institutes and instructors, complete with ratings and real feedback, so you always feel confident in your choice.</p>
                                            </div>
                                            <img src={Rightpoint4} alt="point 1" />
                                        </div>

                                        <div className="flex gap-[15px] items-center pb-[50px]">
                                            <div className="flex flex-col">
                                                <p className="text-[18px] font-bold">AI-Powered Platform</p>
                                                <p className="text-[18px]">We use intelligent technology to match you with the best-fit institute based on your locality, need, and goals.</p>
                                            </div>
                                            <img src={Rightpoint5} alt="point 1" />
                                        </div>
                                </div>

                                <div className="w-full flex justify-center mt-[-60px]">
                                        <img src={VLIAddValueMobile} alt="VLI" />
                                </div>
                            </div>

                        </div>
                    </div>

                    <FrequentlyAskedQuestions />
                </>
            )}
      </div>
    </div>
  );
};

export default HowVLIAddValueBtn;
